export default "__VITE_ASSET__c8f901e4__"